<template>
    <div class="wrapper" :style="style" @click.stop="clickStop">
        <TwoLayerPopup
            :menus="options"
            direct="bottom"
            :left="0"
            :topOrBottom="1"
            :isShow="true"
            @menuChange="select"
        />
    </div>
</template>

<script>
import TwoLayerPopup from "@/views/zhiji/bComponents/popupMenu/TwoLayerPopup";

export default {
    name: "ContextMenu",
    props: ["data"],
    components: {
        TwoLayerPopup,
    },
    computed: {
        style() {
            // todo做一些适配
            return {
                left: `${this.data.x}px`,
                top: `${this.data.y}px`,
            };
        },
        options() {
            return this.data.options || [];
        },
    },
    methods: {
        select(option) {
            this.$emit("change", option);
        },
        clickStop() {
            // nothing
        }
    }
};
</script>

<style lang="less" scoped>
.wrapper {
    position: absolute;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 ~"/" 10%);
}
/deep/.el-cascader-menu__wrap {
    height: auto;
}
</style>
